(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  var startedForms = typeof WeakSet === 'function' ? new WeakSet() : null;

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function emit(eventName, payload) {
    var detail = Object.assign({ event: eventName }, payload || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    window.dispatchEvent(new CustomEvent('marble:analytics', { detail: detail }));
  }

  function closestProductLink(target) {
    return target.closest(
      '[data-product-card] a, .furniture-card a, .fp-related-card a, a[data-product-link]'
    );
  }

  if (main && main.dataset.pageType === 'product') {
    emit('view_item', {
      ecommerce: {
        items: [
          {
            item_id: clean(main.dataset.productId),
            item_name: clean(main.dataset.productTitle),
            item_category: 'Mobilier en pierre naturelle sur devis'
          }
        ]
      }
    });
  }

  document.addEventListener('click', function (event) {
    var productLink = closestProductLink(event.target);
    if (productLink) {
      var productCard = productLink.closest(
        '[data-product-card], .furniture-card, .fp-related-card'
      );
      emit('select_item', {
        link_url: productLink.href,
        item_name: clean(
          productLink.dataset.productTitle ||
            (productCard ? productCard.textContent : productLink.textContent)
        )
      });
    }

    var quoteLink = event.target.closest(
      'a[href*="#bespoke-contact"], a[href*="#project-form"], a[href*="#quote-form"], [data-quote-cta]'
    );
    if (quoteLink) {
      emit('quote_cta_click', {
        cta_text: clean(quoteLink.textContent || quoteLink.getAttribute('aria-label')),
        link_url: quoteLink.href || ''
      });
    }
  });

  function isQuoteForm(form) {
    return form.matches('.fp-form, [data-quote-form], #bespoke-contact form');
  }

  function quotePayload(form) {
    return {
      lead_source: main && main.dataset.pageType === 'product' ? 'product_quote' : 'bespoke_project',
      form_id: form && form.id ? form.id : 'quote-form',
      product_id: main ? clean(main.dataset.productId) : '',
      product_name: main ? clean(main.dataset.productTitle) : ''
    };
  }

  function successStorageKey() {
    return 'marble:quote-success:' + window.location.pathname;
  }

  function clearTrackedSuccess() {
    try {
      window.sessionStorage.removeItem(successStorageKey());
    } catch (error) {
      window.__marbleTrackedQuoteSuccess = '';
    }
  }

  function isSuccessAlreadyTracked() {
    try {
      return window.sessionStorage.getItem(successStorageKey()) === 'true';
    } catch (error) {
      return window.__marbleTrackedQuoteSuccess === successStorageKey();
    }
  }

  function markSuccessAsTracked() {
    try {
      window.sessionStorage.setItem(successStorageKey(), 'true');
    } catch (error) {
      window.__marbleTrackedQuoteSuccess = successStorageKey();
    }
  }

  document.addEventListener('focusin', function (event) {
    var form = event.target.closest('form');
    if (!form || !isQuoteForm(form)) return;
    if (startedForms && startedForms.has(form)) return;
    if (startedForms) startedForms.add(form);
    emit('begin_quote', { form_id: form.id || 'quote-form' });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !isQuoteForm(form)) return;
    clearTrackedSuccess();
    emit('quote_form_submit', quotePayload(form));
  });

  var successMessage = document.querySelector(
    '.fp-form .fp-form__status--success, #bespoke-contact form .bespoke-home__form-status, [data-quote-form] [data-form-success]'
  );

  if (successMessage && !isSuccessAlreadyTracked()) {
    var successForm = successMessage ? successMessage.closest('form') : null;
    var successPayload = quotePayload(successForm);

    markSuccessAsTracked();
    emit('generate_lead', successPayload);
    emit(
      'quote_form_success',
      Object.assign({ page_type: main ? main.dataset.pageType : '' }, successPayload)
    );
  }
})();
